<div class="alert alert-danger mb-0">
	<div class="row justify-content-between align-items-center g-0">
		<div class="col-24 col-lg">
			<div class="d-flex align-items-center">
				<fa-icon class="alert-icon" [icon]="iconError"></fa-icon>

				<div class="ms-3">
					<h3 class="mb-0">{{ heading }}</h3>
					<div>{{ message }}</div>
				</div>
			</div>
		</div>

		<div class="col-24 col-lg-auto mt-3 mt-lg-0">
			<button type="button" class="btn btn-danger w-100" (click)="onRetry()" i18n="@@try-again">Try Again</button>
		</div>
	</div>
</div>
